import { useQuery } from "react-query";
import { z } from "zod";
import { agent } from "~/util/agent";
import { VenueOrderAdminSchema } from "./venueOrderSchema";

const QUERY_KEY = "venue-orders";

const HedgeAllocationSchema = z.object({
  id: z.string().uuid(),
  equity_swap_id: z.string().uuid(),
  venue_order_id: z.string().uuid(),
  quantity: z.string(),
  mode: z.enum(["BackToBack", "Pooled", "HouseNet"]),
  allocation_rule: z.string(),
  reverses_allocation_id: z.string().uuid().nullable(),
  allocated_at: z.string().nullable(),
  allocated_by: z.string().nullable(),
  source_event_id: z.string().uuid().nullable(),
});

const VenueOrderDetailSchema = z.object({
  venue_order: VenueOrderAdminSchema,
  allocations: z.array(HedgeAllocationSchema),
});

const useUnassignedVenueOrders = (venueAccountId?: string) =>
  useQuery([QUERY_KEY, "unassigned", venueAccountId], async () => {
    const params = new URLSearchParams();
    params.set("status", "unassigned");
    if (venueAccountId) {
      params.set("venue_account_id", venueAccountId);
    }
    const data = await agent(`venue_orders?${params.toString()}`).json<unknown>();
    return z.array(VenueOrderAdminSchema).parse(data);
  });

const useVenueOrderDetail = (id?: string) =>
  useQuery(
    [QUERY_KEY, id],
    async () => {
      const data = await agent(`venue_orders/${id}`).json<unknown>();
      return VenueOrderDetailSchema.parse(data);
    },
    { enabled: !!id }
  );

export { HedgeAllocationSchema, VenueOrderAdminSchema, useUnassignedVenueOrders, useVenueOrderDetail };
